<template>
  <div>
      <span :endTime="endTime" :callback="callback" :endText="endText" :type='type' class="timeCss" v-if="endTime!='NaN'&type==1?true:false">
        <!-- 普通的倒计时 -->
        <slot>
        {{content}}
        </slot>
    </span>
      <span :endTime="endTime" :callback="callback" :endText="endText" :type='type' class="timeCss"   v-if="endTime!='NaN'&type==2?true:false">
        <!-- 翻页的倒计时 -->
        <slot>
        {{content}}
        </slot>
    </span>
      <span :endTime="endTime" :callback="callback" :endText="endText" :type='type' class="timeCss"  v-if="endTime!='NaN'&type==3?true:false">
        <!-- 头部的倒计时 -->
        <slot>
        {{content}}
        </slot>
    </span>
  </div>
</template>
<script>
  export default {
    data(){
      return {
      content: '',
      }
    },
    // props:['endTime','endText','callback','type',],
    props:{
      endTime:{
        type: String,
        default :''
      },
      endText:{
        type : String,
        default:'已结束'
      },
      callback : {
        type : Function,
        default :''
      },
      type : {
        type : String,
        default :'1'
      }
    },
    watch: {
        endTime: {
          handler () {
            // 监听获取ajax数据
            this.countdowm(this.endTime)
          },
          // 监听到数据变化时立即调用
          immediate: true
      }
    },

    created(){
      this.countdowm(this.endTime)
    },
    mounted () {
    //  this.countdowm(this.endTime)
    },
    methods: {
      countdowm(timestamp){
      let self = this;
      let timer = setInterval(function(){
        let nowTime = new Date();
        let endTime = new Date(Number(timestamp));
        let t = endTime.getTime() - nowTime.getTime();
        if(t>0){
          let day = Math.floor(t/86400000);
          let hour=Math.floor((t/3600000)%24);
          let min=Math.floor((t/60000)%60);
          let sec=Math.floor((t/1000)%60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          let format = '';
          if(day > 0){
            format = `${day}天${hour}小时${min}分${sec}秒`;
          } 
          if(day <= 0 && hour > 0 ){
            format = `00天${hour}小时${min}分${sec}秒`; 
          }
          if(day <= 0 && hour <= 0){
            // format =`00天00小时${min}分${sec}秒`;
            format =`00天00小时${min}分${sec}秒`;
          }
          self.content = format;
          }else{
           clearInterval(timer);
           self.content = self.endText;
           self._callback();
          }
         },1000);
        },
        _callback(){
        if(this.callback && this.callback instanceof Function){
           this.callback(...this);
         }
      }
    }
  }
</script>
<style scoped lang="less">
span.timeCss {
    font-size: 14px;
    color: #78b942;
}
</style>


// WEBPACK FOOTER //
// src/components/countDown.vue